import React, { FC, useCallback, useMemo } from 'react';

import { Item, DropdownOption } from '../Item';


export type SelectAllProps = {
    value: DropdownOption[];
    onChange: (options: DropdownOption[]) => void;
    options: DropdownOption[];
};

export const SelectAll: FC<SelectAllProps> = ({
    value,
    options,
    onChange,
}) => {
    const isSelected = useMemo(
        () =>
            Array.isArray(value) &&
            options.every(o => value.some(v => o.value === v.value)),
        [value, options],
    );
    const onSelect = useCallback(
        () => onChange(!isSelected ? options : []),
        [options, isSelected, onChange],
    );

    return (
        <Item
            data={{
                value: null,
                label: 'Выбрать все',
            }}
            onSelect={onSelect}
            isMulti
            isSelected={isSelected}
        />
    );
};
